export default __webpack_public_path__ + "static/broadcastImg1-0be7a8172d46afe2fba670f6d9c1ac52.webp";